import classNames from 'classnames';
import _ from 'lodash';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import Lottie from 'react-lottie-player';
import { useStorage } from '../../hooks/use-storage';
import { layoutDefaults } from '../../utils/layout-defaults';
import { publicResources } from '../../utils/public-resources';
import animationData from './empty-congratulations.json';

const animateLottie = 'animate__animated animate__fadeIn animate__delay-1s';
const animateFromUp =
  'animate__animated animate__bounceInDown animate__delay-1s';
const animateFromDown = 'animate__animated animate__fadeInUp animate__delay-1s';

function EmptyCongratulationsAnimated() {
  const { showingModal } = useStorage();
  const { t } = useTranslation();
  const classes = useStyles();
  const lottieRef = useRef();

  useEffect(() => {
    if (showingModal) {
      lottieRef.current.stop();
    } else {
      _.delay(() => {
        lottieRef.current.play();
      }, 600);
    }
  }, [showingModal]);

  // const { width } = useWindowDimensions();

  // console.log(width);

  // console.log(BackgroundSVG);

  return (
    <div className={classes.container}>
      <Lottie
        ref={lottieRef}
        // loop={false}
        loop
        play
        // useSubframes
        // className={classNames(classes.animation)}
        className={classNames(classes.animation, animateLottie)}
        style={{ '--animate-delay': '1.9s' }}
        animationData={animationData}
      />
      <div className={classes.centered}>
        <span
          className={classNames(classes.congrats, animateFromUp)}
          style={{ '--animate-delay': '0.0s', '--animate-duration': '1.3s' }}
        >
          {t('empty-congrats.congratulations')}
        </span>
        <div
          className={classNames(classes.title, animateFromDown)}
          style={{ '--animate-delay': '0.5s' }}
        >
          {t('empty-congrats.reason_1')}
          <b>{t('empty-congrats.reason_2')}</b>
          <br />
          {t('empty-congrats.reason_3')}
          <b>{t('empty-congrats.reason_4')}</b>
        </div>
        <img
          className={classNames(classes.logo, animateFromDown)}
          style={{ '--animate-delay': '0.7s' }}
          src={publicResources.image.logoFull}
          alt=""
        />
      </div>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    // border: '1px solid white',
    // backgroundImage: `url(${BackgroundSVG})`,
    // backgroundRepeat: 'no-repeat',
    // backgroundPosition: 'right 0px top 0px',
    // backgroundSize: '500%',
    position: 'relative',
    display: 'flex',

    alignItems: 'center',
    justifyContent: 'center',

    // border: '1px solid yellow',
  },
  animationContainer: {
    position: 'relative',
    display: 'flex',

    alignItems: 'center',
    justifyContent: 'center',

    // border: '1px solid white',
  },
  animation: {
    width: '100%',
  },
  centered: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',

    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',

    // border: '1px solid red',
  },
  title: {
    textAlign: 'center',
    fontSize: layoutDefaults.biggerFontSize,
    fontWeight: '400',
    opacity: 0.85,
    // textShadow: '0px 0px 2px white',
  },
  congrats: {
    fontSize: layoutDefaults.extraFontSize,
    fontWeight: 'bold',
    marginBottom: layoutDefaults.verticalMargin,
  },
  logo: {
    width: 90,
    marginTop: layoutDefaults.smallerVerticalMargin,
    // border: '1px solid white',
  },
  // backgroundContainer: {
  //   flex: 1,
  //   position: 'relative',
  //   width: '100%',
  //   height: 200,
  //   border: '1px solid white',
  // },
  // background: {
  //   position: 'relative',
  //   // width: '100%',
  //   // top: 0,
  //   // right: 0,
  //   // left: 0,
  //   // bottom: 0,
  // },
});

export { EmptyCongratulationsAnimated };
